import { getLocale } from "../runtime";

const sv_offerwillexpirein = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Erbjudandet går ut om`
};

const offerwillexpirein = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_offerwillexpirein(inputs)
	return "offerWillExpireIn";
};

export { offerwillexpirein as "offerWillExpireIn" };